function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#012169"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,14.375h30v1.25H0v-1.25Z",
    style: {
      fill: "#ffc72c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,20.625l-.324-1.293-.926.958.366-1.281-1.281.366.958-.927-1.293-.323,1.293-.323-.958-.927,1.281.366-.366-1.281.926.958.324-1.293.324,1.293.926-.958-.366,1.281,1.281-.366-.958.927,1.293.323-1.293.323.958.927-1.281-.366.366,1.281-.926-.958-.324,1.293Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNr);
export default __webpack_public_path__ + "static/media/NR.96259ba528959a6130378812c1d3a7f0.svg";
export { ForwardRef as ReactComponent };